function MondayLogoSVG() {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      width="50"
      height="50"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 59.3"
    >
      <path
        fill="#FB275D"
        d="M13,58.8c-2.1,0-4.2-0.5-6.1-1.6c-1.9-1.1-3.4-2.6-4.5-4.5c-1-1.9-1.6-4-1.5-6.1s0.7-4.2,1.8-6L24.2,6.3
	c1.1-1.8,2.7-3.4,4.5-4.4c1.9-1,4-1.6,6.1-1.5c2.1,0,4.2,0.7,6.1,1.8c1.8,1.1,3.3,2.7,4.3,4.6c1,1.9,1.5,4,1.4,6.1s-0.8,4.2-2,6
	L23.2,53.2c-1.1,1.7-2.6,3.2-4.4,4.1C17,58.3,15,58.8,13,58.8z"
      />
      <path
        fill="#FFCC00"
        d="M50.3,58.6c-2.1,0-4.3-0.5-6.1-1.6c-1.9-1.1-3.4-2.6-4.5-4.5c-1-1.9-1.6-4-1.5-6.1s0.7-4.2,1.8-6L61.5,6.1
	c1.1-1.9,2.6-3.4,4.5-4.5C67.9,0.5,70,0,72.2,0s4.3,0.7,6.1,1.8c1.8,1.1,3.3,2.7,4.4,4.6c1,1.9,1.5,4,1.3,6.2c-0.1,2.1-0.8,4.2-2,6
	L60.5,53c-1.1,1.7-2.6,3.1-4.4,4.1C54.4,58.1,52.4,58.6,50.3,58.6z"
      />
      <path
        fill="#00CC6F"
        d="M87.7,58.4c6.7,0,12-5.3,12-11.7c0-6.4-5.5-11.6-12.1-11.6c-6.7,0-12,5.3-12,11.7C75.6,53.3,81,58.5,87.7,58.4z"
      />
    </svg>
  );
}

export default MondayLogoSVG;
